import React from 'react';
import RefundPolicy from '../components/RefundPolicy';

const RefundPolicyPage = () => {
  return (
    <>
      <RefundPolicy />
    </>
  );
};

export default RefundPolicyPage;
